import { Moon, Sun } from './Icons';
import { useTheme } from '../hooks/useTheme';
import { useTranslation } from '../contexts/TranslationContext';
import type { AppTheme } from '../utils/appTheme';

interface ThemeOption {
  theme: AppTheme;
  labelKey: string;
  titleKey: string;
  Icon: typeof Sun;
}

const THEME_OPTIONS: ThemeOption[] = [
  {
    theme: 'light',
    labelKey: 'theme.light',
    titleKey: 'theme.switchToLight',
    Icon: Sun,
  },
  {
    theme: 'dark',
    labelKey: 'theme.dark',
    titleKey: 'theme.switchToDark',
    Icon: Moon,
  },
];

interface ThemeSwitcherProps {
  compact?: boolean;
  plain?: boolean;
}

export function ThemeSwitcher({ compact = false, plain = false }: ThemeSwitcherProps) {
  const { theme, setTheme } = useTheme();
  const { t } = useTranslation();
  const nextTheme = theme === 'light' ? 'dark' : 'light';
  const nextThemeOption = THEME_OPTIONS.find(({ theme: optionTheme }) => optionTheme === nextTheme) ?? THEME_OPTIONS[0];

  return (
    <button
      type="button"
      onClick={() => setTheme(nextTheme)}
      className={`${plain ? 'bg-transparent text-slate-200 hover:text-orange-100' : 'theme-control border-0'} inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg transition-colors ${compact ? '' : 'sm:h-10 sm:w-10'}`}
      title={t(nextThemeOption.titleKey)}
      aria-label={t(nextThemeOption.titleKey)}
    >
      <nextThemeOption.Icon className="h-4 w-4" />
    </button>
  );
}
